import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=cee929be&scoped=true&"
import script from "./PrivacyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=cee929be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee929be",
  null
  
)

export default component.exports